// import DashboardIcon from '@mui/icons-material/Dashboard';
// import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
// import BarChartIcon from '@mui/icons-material/BarChart';
// import DescriptionIcon from '@mui/icons-material/Description';
// import LayersIcon from '@mui/icons-material/Layers';
// import SupportAgentIcon from '@mui/icons-material/SupportAgent';
// import { useRoleModuleMutation } from '../../features/user/authApi';
// import { useEffect } from 'react';

//   const [roleModule, { isLoading,isError,data  }] = useRoleModuleMutation()

// useEffect(() => {
//   roleModule();
// }, []);



// const Navigate = [
//   // {
//   //   kind: 'header',
//   //   title: 'Main items',
//   // },
//   {
//     segment: 'dashboard',
//     title: 'Dashboard',
//     icon: <DashboardIcon />,
//   },
//   // {
//   //   segment: 'orders',
//   //   title: 'Orders',
//   //   icon: <ShoppingCartIcon />,
//   // },
//   {
//     kind: 'divider',
//   },
//   // {
//   //   kind: 'header',
//   //   title: 'Analytics',
//   // },
//   {
//     segment: 'reports',
//     title: 'Reports',
//     icon: <BarChartIcon />,
//     children: [
//       {
//         segment: 'org',
//         title: 'Organization',
//         icon: <SupportAgentIcon />,
//       },
    
//     ],
//   },
//   // {
//   //   segment: 'integrations',
//   //   title: 'Integrations',
//   //   icon: <LayersIcon />,
//   // },
// ];

// export default Navigate




// src/hooks/useFilteredNavigate.js


import { useEffect, useState, useMemo } from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import BarChartIcon from '@mui/icons-material/BarChart';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import SavingsIcon from '@mui/icons-material/Savings';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import MoneyIcon from '@mui/icons-material/Money';
import { useRoleModuleMutation } from '../../features/user/authApi';

const useFilteredNavigate = () => {
  const [roleModule, { data }] = useRoleModuleMutation();

  useEffect(() => {
    roleModule(); 
  }, []);



  const Navigate = useMemo(() => {
    const nav = [
      {
        segment: 'dashboard',
        title: 'Dashboard',
        icon: <DashboardIcon />,
      },
      {
        kind: 'divider',
      },
      {
        segment: 'reports',
        title: 'Reports',
        icon: <BarChartIcon />,
        children: [],
      },
    ];

    if (data?.data?.accessPer?.includes('kfd_org')) {
      const reports = nav.find((item) => item.segment === 'reports');
      if (reports) {
        reports.children.push({
          segment: 'org',
          title: 'Organization',
          icon: <SupportAgentIcon />,
        },
        {
          segment: 'noloan',
          title: 'Approach',
          icon: <SavingsIcon />,
        },
        {
          segment: 'EmployeeReport',
          title: 'Win Team',
          icon: <EmojiEventsIcon />,
        },
        {
          segment: 'CollectionReport',
          title: 'Collection Report',
          icon: <MoneyIcon />,
        }
      );
      }
    }

    return nav;
  }, [data?.data?.accessPer]);

  return Navigate;
};

export default useFilteredNavigate;
